import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ng-pacs-lib',
  template: `
    <p>
      ng-pacs-lib works!
    </p>
  `,
  styles: []
})
export class PacsLibComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
